"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var primary = _ref.palette.primary;
  return {
    root: {
      textTransform: 'uppercase',
      color: primary.main
    },
    locale: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 56
    },
    opener: {
      cursor: 'pointer'
    },
    listWrapper: {
      transition: 'height .3s',
      overflow: 'hidden'
    },
    fakeDiv: {
      position: 'absolute',
      top: -99999
    },
    list: {
      height: '100%',
      overflowY: 'scroll',
      listStyle: 'none',
      padding: '8px 0 0 0',
      margin: 0,
      borderTop: '1px solid #666',
      '& li': {
        margin: 0,
        padding: '8px 0',
        cursor: 'pointer'
      }
    },
    listItemSelected: {
      opacity: 0.3,
      cursor: 'auto'
    }
  };
}, {
  name: 'LocalePicker'
});
exports.useStyles = useStyles;